// Registro del service worker (src/service-worker.js). Basado en el
// boilerplate oficial de create-react-app para PWA, recortado a lo que este
// sitio usa de verdad.
//
// Solo se registra en producción y solo si el sitio se sirve desde el mismo
// origin que PUBLIC_URL — en un iframe de preview o un origin distinto,
// registrar el service worker no funcionaría y solo generaría ruido en la
// consola.
const isLocalhost = Boolean(
    window.location.hostname === "localhost" ||
        window.location.hostname === "[::1]" ||
        window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4]\d|[01]?\d\d?)){3}$/),
);

export function register(config) {
    if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) return;

    const publicUrl = new URL(process.env.PUBLIC_URL || "", window.location.href);
    if (publicUrl.origin !== window.location.origin) return;

    const run = () => {
        const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
        if (isLocalhost) checkValidServiceWorker(swUrl, config);
        else registerValidSW(swUrl, config);
    };

    // `load` no dispara si el documento YA estaba en "complete" cuando este
    // código corrió (ej. bundle grande que tarda en parsear/ejecutar en un
    // equipo lento, o hidratación tras un prerenderizado): un listener a un
    // evento que ya pasó no se ejecuta nunca, y el sitio se queda sin
    // registrar el service worker en silencio, sin ningún error.
    if (document.readyState === "complete") run();
    else window.addEventListener("load", run);
}

/**
 * Aviso de "hay versión nueva ya activa".
 *
 * El service worker nuevo se activa solo (skipWaiting + clientsClaim), pero
 * la página que YA está abierta sigue ejecutando el JavaScript viejo hasta
 * que se recarga. En un sitio normal eso dura minutos; en la app instalada
 * puede durar días, porque queda en segundo plano y nunca se recarga.
 * Resultado: se corregía un error, se desplegaba, y quien tenía la app
 * abierta seguía viendo el error. Aquí solo se levanta la bandera; quien
 * decide cuándo recargar es App.js, en la siguiente navegación (nunca a
 * media página, para no tirar un formulario o un pago en curso).
 */
export function isUpdateReady() {
    return Boolean(window.__carpepelUpdateReady);
}

function watchForUpdates(registration) {
    // Solo cuenta como "actualización" si ya había un service worker
    // controlando: la primera instalación también dispara controllerchange
    // (clientsClaim) y en ese caso no hay nada viejo que reemplazar.
    const hadController = Boolean(navigator.serviceWorker.controller);
    navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (hadController) window.__carpepelUpdateReady = true;
    });
    // El navegador solo busca una versión nueva al cargar la página o cada
    // ~24 h. Al volver a la app desde segundo plano se pregunta a mano.
    document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") registration.update().catch(() => {});
    });
}

function registerValidSW(swUrl, config) {
    navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
            watchForUpdates(registration);
            registration.onupdatefound = () => {
                const installingWorker = registration.installing;
                if (installingWorker == null) return;
                installingWorker.onstatechange = () => {
                    if (installingWorker.state === "installed") {
                        if (navigator.serviceWorker.controller) {
                            config?.onUpdate?.(registration);
                        } else {
                            config?.onSuccess?.(registration);
                        }
                    }
                };
            };
        })
        .catch((error) => {
            console.error("[pwa] Error registrando el service worker:", error);
        });
}

// En localhost, confirma primero que /service-worker.js existe y es de
// verdad JS antes de registrarlo — evita un loop de errores si el dev
// server no lo está sirviendo (no pasa por webpack en `craco start`).
function checkValidServiceWorker(swUrl, config) {
    fetch(swUrl, { headers: { "Service-Worker": "script" } })
        .then((response) => {
            const contentType = response.headers.get("content-type");
            if (response.status === 404 || (contentType != null && contentType.indexOf("javascript") === -1)) {
                navigator.serviceWorker.ready.then((registration) => {
                    registration.unregister();
                });
            } else {
                registerValidSW(swUrl, config);
            }
        })
        .catch(() => {
            console.log("[pwa] Sin conexión — la app sigue funcionando desde caché si ya se instaló.");
        });
}

export function unregister() {
    if (!("serviceWorker" in navigator)) return;
    navigator.serviceWorker.ready
        .then((registration) => registration.unregister())
        .catch((error) => console.error(error.message));
}
